module.exports = __webpack_public_path__ + "img/Bodyswaps_NO.11ddd0bc.svg";